<template>
  <div>
    <h2 class="content-block-title">{{ title }}</h2>

    <dx-data-grid
      v-if="!loading"
      class="dx-card content-block"
      :data-source="dataSource"
      key-expr="container_id"
      :focused-row-index="0"
      :show-borders="false"
      :focused-row-enabled="true"
      :column-auto-width="true"
      :column-hiding-enabled="true"
    >
      <dx-paging :page-size="20" />
      <dx-pager :show-page-size-selector="true" :show-info="true" :allowed-page-sizes="[5, 10, 20, 30, 50]" />
      <dx-filter-row :visible="true" />

      <dx-column data-field="name" caption="Name" />
      <dx-column data-field="container_id" caption="Container ID" />
      <dx-column data-field="cpu_percent" caption="CPU %" />
      <dx-column data-field="mem_usage" caption="Memory Usage" />
      <dx-column data-field="mem_limit" caption="Memory Limit" />
      <dx-column data-field="mem_percent" caption="Memory %" />
      <dx-column data-field="net_input" caption="Net Input" />
      <dx-column data-field="net_output" caption="Net Output" />
      <dx-column data-field="block_input" caption="Block Input" />
      <dx-column data-field="block_output" caption="Block Output" />
      <dx-column data-field="pids" caption="PIDs" />

    </dx-data-grid>

    <div v-if="loading" class="loading-overlay">
      <DxLoadIndicator :height="60" :width="60" />
    </div>
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxPager,
  DxFilterRow
} from 'devextreme-vue/data-grid';

import { DxLoadIndicator } from 'devextreme-vue/load-indicator';
import axios from 'axios';  

export default {
  name: 'ContainerMetricsGrid',
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxPager,
    DxFilterRow,
    DxLoadIndicator
  },
  data() {
    return {
      title: 'Running Containers Metrics',
      loading: true,
      dataSource: []
    };
  },
  mounted() {
    this.loadContainerMetrics();
  },
  methods: {
    async loadContainerMetrics() {
      try {
        const response = await axios.get('/api/internal/docker/stats');
        // const json = await res.json();
        // this.dataSource = response.data;
        this.dataSource = Array.isArray(response.data) ? response.data : [];
      } catch (err) {
        console.error('Error loading data:', err);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.loading-overlay {
  position: absolute;
  top: 100px;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 10;
}
</style>
